import {ApiModel} from "./api.model";


export const Status = ApiModel.extend({
    props: {
        id: 'number',
        name: 'string',
    },
    extraProperties: 'reject',
});
